import { render, staticRenderFns } from "./mentor-comments.vue?vue&type=template&id=6d3ba8e8&lang=pug"
import script from "./mentor-comments.vue?vue&type=script&lang=js"
export * from "./mentor-comments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports